import Ajax from "@/js/common/ajax";
import Qs from "qs";

export default {
	list(page, params) {
		return Ajax.post("/bank/statement/list", params, {params: page})
	},
	allList(params) {
		return Ajax.post("/bank/statement/all/list", params)
	},
	delete(id) {
		return Ajax.delete(`/bank/statement/${id}`)
	},
	batchDelete(ids) {
		return Ajax.delete(`/bank/statement/batch?` + Qs.stringify({id: ids}, {arrayFormat: 'repeat'}))
	},
	deleteAll(records) {
		return Ajax.post(`/bank/statement/deleteAll`, records)
	},
	batchUpdate(ids, type, params) {
		return Ajax.put(`/cashier/journal/batch?type=${type}&` + Qs.stringify({id: ids}, {arrayFormat: 'repeat'}), params)
	},
	save(params = {}) {
		return Ajax.post(`/cashier/journal`, params)
	},
	generateVoucher(params = []) {
		return Ajax.post(`/cashier/journal/generate/voucher`, params)
	},
	import(params) {
		return Ajax.post(`/bank/statement/import`, params, {'Content-Type': 'multipart/form-data'})
	},
	downloadDetails(params) {
		return Ajax.post(`/bank/statement/download`, params, {
			responseType: 'blob'
		})
	},
}
